import React from 'react';
import { Price } from "components/Price/Price";
import { PriceInput } from 'components/PriceInput/PriceInput';

interface PriceSettingsProps {
    object: any;
}

export const PriceSettings: React.FC<PriceSettingsProps> = ({ object }) => {
    return (
            <div className="d-flex align-items-end w-100 h-100">
                <PriceInput
                    label="defaultValue"
                    name="defaultValue"
                    defaultValue={object?.defaultValue}
       
                    
                />
            </div>
        
    );
}; 